import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ScenarioNavigation.sass';
import { faChevronsLeft, faChevronsRight, faChevronsUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ScenarioNavigationProps {
    scenarios: Array<any>;
    currentScenario: any;
    onScenarioClick: (scenario: any) => void;
    isNavigationEnabled: boolean;
}

export const ScenarioNavigation: React.FC<ScenarioNavigationProps> = ({
    scenarios,
    currentScenario,
    onScenarioClick,
    isNavigationEnabled
}) => {
    const { t } = useTranslation();
    const [isEnabled, setIsEnabled] = useState(false);

    useEffect(() => {
        if (isNavigationEnabled) setIsEnabled(true);

        setIsEnabled(isNavigationEnabled);
        if (isNavigationEnabled) setTimeout(() => {
            setIsEnabled(false);
        }, 3000);
    }, [isNavigationEnabled]);

    return (
        <>


            <div className={`scenario-navigation ${!isNavigationEnabled ? 'disabled' : ''}`}>

                <div className={`arrow-container ${isNavigationEnabled && isEnabled ? 'disappearing' : ''}`}>
                    {isEnabled && <>
                        <div className="arrow-left">
                            <FontAwesomeIcon icon={faChevronsRight} />
                        </div>
                        <div className="arrow-right">
                            <FontAwesomeIcon icon={faChevronsLeft} />
                        </div>
                    </>}
                </div>

                <div
                    className={`scenario-dot ${currentScenario === null ? 'active' : ''} ${!isNavigationEnabled ? 'disabled' : ''}`}
                    onClick={() => isNavigationEnabled && onScenarioClick(null)}
                >
                    SITUATION
                    <div className="scenario-name">{t("models.scenario.baseline")}</div>
                </div>
                {scenarios.map((scenario, index) => (
                    <div
                        key={scenario.id}
                        className={`scenario-dot ${currentScenario?.id === scenario.id ? 'active' : ''} ${!isNavigationEnabled ? 'disabled' : ''}`}
                        onClick={() => isNavigationEnabled && onScenarioClick(scenario)}
                    >
                        {scenario.reference ? scenario.reference : index + 1}
                        <div className="scenario-name">{scenario.name}</div>
                        <div className="arrow">
                            <FontAwesomeIcon icon={faChevronsUp} />
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}; 